import { BaseService } from "services/_baseService";

class AttributesAdminService extends BaseService<any> {
  constructor() {
    super(`attributes`);
  }
}

export default new AttributesAdminService();
